module.exports = __webpack_public_path__ + "static/media/history_2.da1365ea.png";